import "./comision-directiva.scss";

// Función para obtener iniciales del nombre "Apellido, Nombre"
function getInitials(nombre: string): string {
  if (nombre.toLowerCase().startsWith("vacante")) return "—";
  const parts = nombre.split(",").map((s) => s.trim());
  const apellidoInicial = parts[0]?.[0] ?? "";
  const nombreInicial = parts[1]?.[0] ?? "";
  return (apellidoInicial + nombreInicial).toUpperCase();
}

interface Miembro {
  cargo: string;
  nombre: string;
  vacante?: boolean;
  nota?: string;
}

function OrgCard({
  cargo,
  nombre,
  vacante = false,
  nota,
  colorClass,
}: Miembro & { colorClass: string }) {
  return (
    <div
      className={`org-card ${colorClass}${vacante ? " org-card--vacante" : ""}`}
    >
      <div className={`org-card__avatar ${colorClass}`}>
        {getInitials(nombre)}
      </div>
      <div className="org-card__body">
        <span className="org-card__cargo">{cargo}</span>
        <p className="org-card__nombre">{nombre}</p>
        {vacante && nota && (
          <span className="org-card__nota">
            <i className="bi bi-info-circle"></i> {nota}
          </span>
        )}
      </div>
    </div>
  );
}

export default function ComisionDirectiva() {
  return (
    <section id="comision-directiva" className="section cd-page">
      <div className="container section-title fade-up text-center mb-5">
        <h2>Comisión Directiva</h2>
        <p>
          Autoridades del Colegio de Fonoaudiólogos de La Pampa — Período
          vigente.
        </p>
      </div>

      <div className="container fade-up">
        <div className="org-chart">
          {/* ── Fila 1: Presidente ── */}
          <div className="org-row org-row--top">
            <OrgCard
              cargo="Presidente"
              nombre="Roulier, Graciela"
              colorClass="cyan"
            />
          </div>

          {/* Conector vertical */}
          <div className="org-connector org-connector--v" />

          {/* ── Fila 2: Vicepresidente / Secretaria / Prosecretaria / Tesorera ── */}
          <div className="org-row org-row--conduccion">
            <OrgCard
              cargo="Vicepresidente"
              nombre="Mafud, Melina"
              colorClass="cyan"
            />
            <OrgCard
              cargo="Secretaria"
              nombre="Carabajal, Guadalupe"
              colorClass="cyan"
            />
            <OrgCard
              cargo="Prosecretaria"
              nombre="Rabil, Alejandra"
              colorClass="cyan"
            />
            <OrgCard cargo="Tesorera" nombre="Sack, Ornela" colorClass="cyan" />
          </div>

          {/* Conector horizontal + vertical */}
          <div className="org-connector org-connector--h" />
          <div className="org-connector org-connector--v" />

          {/* ── Fila 3: Vocales Titulares ── */}
          <div className="org-section-label green">
            <i className="bi bi-people-fill"></i> Vocales Titulares
          </div>
          <div className="org-row org-row--vocales">
            <OrgCard
              cargo="Vocal Titular"
              nombre="Miranda, Jazmín"
              colorClass="green"
            />
            <OrgCard
              cargo="Vocal Titular"
              nombre="Soler, Yanina"
              colorClass="green"
            />
            <OrgCard
              cargo="Vocal Titular"
              nombre="Alvarez, Maria Emma"
              colorClass="green"
            />
            <OrgCard
              cargo="Vocal Titular"
              nombre="Trombetta, Agustina"
              colorClass="green"
            />
          </div>

          {/* Conector */}
          <div className="org-connector org-connector--h org-connector--violet" />
          <div className="org-connector org-connector--v org-connector--violet" />

          {/* ── Fila 4: Vocales Suplentes ── */}
          <div className="org-section-label violet">
            <i className="bi bi-person-lines-fill"></i> Vocales Suplentes
          </div>
          <div className="org-row org-row--suplentes">
            <OrgCard
              cargo="Vocal Suplente"
              nombre="Toledo, Ludmila"
              colorClass="violet"
            />
            <OrgCard
              cargo="Vocal Suplente"
              nombre="De Guillén, Milagros"
              colorClass="violet"
            />
            <OrgCard
              cargo="Vocal Suplente"
              nombre="Goñi, Luz"
              colorClass="violet"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
